import { render, staticRenderFns } from "./CourseConstructor.vue?vue&type=template&id=31f13dbe&scoped=true&"
import script from "./CourseConstructor.vue?vue&type=script&lang=js&"
export * from "./CourseConstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f13dbe",
  null
  
)

export default component.exports